import { forwardRef, memo } from 'react'

import { Textfield } from '../Elements/Textfield'

type Props = { errorMessage?: string; hint?: string } & JSX.IntrinsicElements['input']
const FormTextfieldInner = forwardRef<HTMLInputElement, Props>(
  ({ className = '', hint = '', errorMessage = '', ...props }, ref) => {
    return (
      <div className={`grid gap-y-2 ${className}`}>
        <Textfield placeholder="メールアドレス" hasError={!!errorMessage} {...props} ref={ref} />
        {hint && <p className="text-xs text-attend font-bold">{hint}</p>}
        {errorMessage && <p className="text-red-500 text-xs font-bold">{errorMessage}</p>}
      </div>
    )
  },
)

export const FormTextfield = memo(FormTextfieldInner)
